import { useDisclosure, VStack } from '@chakra-ui/react';
import { useUserSetting } from 'containers/Navigation/Navigation.hooks.tsx';
import { Modal } from 'Molecules/index.ts';
import { ArrowUpRightIcon } from 'Tokens/Icons/Direction.tsx';
import { Typography } from 'Tokens/index.ts';
import { Image } from '@chakra-ui/react';

export const WelcomeModal = () => {
  const { onClose } = useDisclosure();
  const [hasSeenWelcomeModal, setHasSeenWelcomeModal] = useUserSetting(
    'hasSeenWelcomeModal',
    false
  );

  const handleOnClose = () => {
    setHasSeenWelcomeModal(true);
    onClose();
  };

  return (
    <Modal
      isOpen={!hasSeenWelcomeModal}
      onClose={handleOnClose}
      confirmText="Got it"
      cancelText="Learn more"
      isCentered={true}
      cancelButtonProps={{
        variant: 'ghost',
        rightIcon: <ArrowUpRightIcon />,
      }}
      onConfirm={handleOnClose}
      onCancel={() =>
        window.open(
          'https://insights.issgovernance.com/posts/iss-corporate-acquires-sustainability-reporting-software-provider-celsia/',
          '_blank'
        )
      }
      size="md"
      headerBgColor="bg.info.muted"
      customHeader={
        <VStack
          width="100%"
          alignContent="center"
          height="122px"
          marginLeft="32px"
          paddingTop="32px"
        >
          <Image src={`/assets/iss_logo.svg`} width="172px" />
          <Typography variant="detail">Sustainability Reporting (prev. Celsia)</Typography>
        </VStack>
      }
    >
      <VStack alignItems="start">
        <Typography variant="h1">Celsia Platform updates</Typography>
        <Typography variant="detail">
          We've updated the platform to reflect our integration with ISS-Corporate. You'll notice a
          <b> new logo and name</b>, and we're working on additional improvements to enhance the
          overall experience.
        </Typography>
        <Typography variant="detail">
          You can continue to use the platform as usual - there will be no interruption to your
          service.
        </Typography>
      </VStack>
    </Modal>
  );
};
